// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"team_wrapper___N8Nw","textWrapper":"team_textWrapper__dJHI2","description":"team_description__kYuJ5","title":"team_title___fuQk"};